import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import { safeSessionStorage } from './safeStorage';

const injectShiftSessionId = (form) => {
	const shiftSessionId = safeSessionStorage.getItem('SaveShiftSession');

	if (shiftSessionId) {
		createOrUpdateHiddenField(
			form,
			'_custom=SHIFT_SESSION_ID=-1=shiftSessionId',
			shiftSessionId
		);
	}
};

export default injectShiftSessionId;
